@use "../../../styles/text";
@use "../../../styles/elevation";

hp6-table-header-panel {
  display: none;

  &[is-visible] {
    display: block;
    z-index: 2;
  }

  @include elevation.elevation-mid;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--color-neutral-xlight);
  padding-left: var(--spacing-xs);
  padding-right: var(--spacing-xs);
  padding-bottom: var(--spacing-xs);
  text-align: left;

  .panel-section:first-of-type {
    margin-top: var(--spacing-xs);
  }

  .panel-section {
    margin-top: var(--spacing-sm);
    color: var(--color-text-base);

    // 2 columns total - first column grows
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;

    .panel-form {
      grid-row-start: 1;
      grid-column-start: 1;
    }

    .clear-button-container {
      grid-row-start: 1;
      grid-column-start: 2;

      button {
        visibility: hidden;

        &.is-visible {
          visibility: visible;
        }
      }
    }

    button {
      // TODO: it is possible that `button align-items: baseline;` is required
      // because of a quirk in hp6-button-decorator
      align-items: baseline;

      padding: 0;
    }
  }
}
